<div class="main-container">
  <section class="top-section">
    <img src="/assets/logo/logo-full-green.png" alt="" />
    <br />
    <label for="">{{ companyName }}</label>
  </section>

  <section class="slide-container">
    <img src="/assets/sing-up/3.png" alt="" />
  </section>

  <section class="sing-up-title-wrapper">
    <h1>Company Information</h1>
    <label for="">Please enter the company information.</label>
  </section>

  <section class="log-out">
    <label for="" class="email">{{ currentUser.email }}</label>
    <span (click)="logOut()"> Log out </span>
    <mat-icon class="user-icon" mat-raised-button (click)="openBottomSheet()"
      >person</mat-icon
    >
    <ng-template let-bottomSheetRef="bottomSheetRef" #templateBottomSheet>
      <div class="bottom-sheet">
        <div class="">
          <label for="">{{ currentUser.email }}</label>

          <gbui-button (click)="logOut()" class="">Log out</gbui-button>
        </div>
      </div>
    </ng-template>
  </section>
  <section class="form">
    <div class="company">
      <div [formGroup]="companyFrom">
        <div class="">
          <div
            class="input-container"
            style="width: calc(100% - 30px) !important"
          >
            <label class="input-label">Select Industry (optional)</label>
            <gbui-input
              class="inputs"
              select
              style="width: 100%"
              [ngClass]="{
                'placeholder-select':
                  companyFrom.controls['industry'].value == '',
                'invalid-input':
                  !companyFrom.controls['industry'].valid &&
                  companyFrom.controls['industry'].touched
              }"
              formControlName="industry"
              placeholder="Select"
            >
              <gbui-option
                value="{{ industry.name }}"
                *ngFor="let industry of industries"
                >{{ industry.parsedName }}</gbui-option
              >
            </gbui-input>
            <label
              class="scale-up-ver-top"
              *ngIf="
                !companyFrom.controls['industry'].valid &&
                companyFrom.controls['industry'].touched
              "
            >
              Required
            </label>
          </div>
        </div>
      </div>
      <div class="companies-forms" [formGroup]="addressForm">
        <div class="input-container">
          <label class="input-label">Street</label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !addressForm.controls['street1'].valid &&
                addressForm.controls['street1'].touched
            }"
            formControlName="street1"
            placeholder="Enter street"
          >
          </gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !addressForm.controls['street1'].valid &&
              addressForm.controls['street1'].touched
            "
          >
            Required
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Street 2 (optional)</label>
          <gbui-input
            class="inputs"
            simple
            formControlName="street2"
            placeholder="Enter street 2"
          >
          </gbui-input>
        </div>
        <div class="input-container">
          <label class="input-label">City</label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !addressForm.controls['city'].valid &&
                addressForm.controls['city'].touched
            }"
            formControlName="city"
            placeholder="Enter city name"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !addressForm.controls['city'].valid &&
              addressForm.controls['city'].touched
            "
          >
            Required
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">State </label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !addressForm.controls['state'].valid &&
                addressForm.controls['state'].touched
            }"
            formControlName="state"
            placeholder="Enter state name"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !addressForm.controls['state'].valid &&
              addressForm.controls['state'].touched
            "
          >
            Required
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Zip code</label>
          <input
            placeholder="Enter zip code"
            type="number"
            class="simulate-input"
            formControlName="zip"
            [ngClass]="{
              'invalid-input':
                !addressForm.controls['zip'].valid &&
                addressForm.controls['zip'].touched
            }"
          />
          <!-- <gbui-input
            class="inputs"
            simple
            type="number"
            [ngClass]="{
              'invalid-input':
                !addressForm.controls['zip'].valid &&
                addressForm.controls['zip'].touched
            }"
            formControlName="zip"
            placeholder="Enter zip code"
          >
          </gbui-input> -->
          <label
            class="scale-up-ver-top"
            *ngIf="
              !addressForm.controls['zip'].valid &&
              addressForm.controls['zip'].touched
            "
          >
            Invalid Zip Code
          </label>
        </div>
        <div class="input-container">
          <label class="input-label">Country</label>
          <gbui-input
            class="inputs"
            simple
            [ngClass]="{
              'invalid-input':
                !addressForm.controls['country'].valid &&
                addressForm.controls['country'].touched
            }"
            formControlName="country"
            placeholder="Enter country"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !addressForm.controls['country'].valid &&
              addressForm.controls['country'].touched
            "
          >
            Required
          </label>
        </div>
      </div>
    </div>
  </section>
  <section class="button-container">
    <gbui-button
      [disabled]="companyFrom.invalid || addressForm.invalid"
      [busy]="(addCompanyLoading$ | async) ?? false"
      (click)="save()"
      >Save information and proceed</gbui-button
    >
  </section>
</div>
